import { render, staticRenderFns } from "./IndentedIncomeInsight.vue?vue&type=template&id=6b341594&scoped=true"
import script from "./IndentedIncomeInsight.vue?vue&type=script&lang=js"
export * from "./IndentedIncomeInsight.vue?vue&type=script&lang=js"
import style0 from "./IndentedIncomeInsight.vue?vue&type=style&index=0&id=6b341594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b341594",
  null
  
)

export default component.exports